<section class="community community-{{ design }}">
  <div class="header">
    <div class="overlay">
      <div class="bar" [class.active]="arrow">
        <div class="my-input search" style="position: relative">
          <div class="my-input__title">{{ "" }}</div>
          <input type="text" [(ngModel)]="maps.search" placeholder="Search" (keydown.enter)="openFilterModal(filterPopup)"/>

        </div>
        <div class="my-input">
          <div class="my-input__title">Postal</div>
          <input type="text" [(ngModel)]="maps.postalCode" placeholder="Postal Code" />
        </div>
        <div class="my-input">
          <div class="my-input__title">Radius</div>
          <select [(ngModel)]="maps.radius">
            <option value="0" selected disabled>Radius</option>
            <option *ngFor="let radius of [0.2, 1, 2, 5, 'All']" [value]="radius">
              {{ radius == 'All' ? 'All' : radius < 1 ? radius * 1000 + "m" : radius + "km" }} </option>
          </select>
        </div>
        <div class="icon-search" (click)="openFilterModal(filterPopup)">
          <i class="fa-solid fa-search"></i>
        </div>
        <div class="keyword" *ngIf="popularKeywords.length > 0">
          <p class="keyword__title">Popular Search</p>
          <p class="d-none" *ngFor="let row of popularKeywords">{{ row.text }}</p>
          <div #keywordContainer class="buttons">
            <button class="keyword__btn" *ngFor="let row of popularKeywords"
              (click)="maps.search = row.text; openFilterModal(filterPopup)">{{ row.text }}</button>
          </div>
        </div>
        <!-- <i class="fa-solid fa-angle-down arrow" (click)="arrow = !arrow"></i> -->
      </div>
    </div>
  </div>
  <!-- <div class="keyword" *ngIf="popularKeywords.length > 0">
    <h2 class="keyword__title">Popular Search</h2>
    <h3 class="d-none" *ngFor="let row of popularKeywords">{{ row.text }}</h3>
    <div #keywordContainer class="buttons" [class.active]="!moreButtons">
      <button class="keyword__btn" *ngFor="let row of popularKeywords"t
        (click)="maps.search = row.text; openFilterModal(filterPopup)">{{ row.text }}</button>
    </div>
    <i (click)="moreButtons = !moreButtons" [class.active]="moreButtons" *ngIf="itemsHeight > 5.6 * 14"
      class="fas fa-chevron-down"></i>
  </div> -->
</section>


<ng-template #filterPopup let-modal>
  <div class="modal-map">
    <div class="modal-map__close" (click)="modal.dismiss('Cross click')">
      <i class="fa-solid fa-times"></i>
    </div>
    <div class="modal-body">
      <div class="row">
        <div class="col-lg-6">
          <app-google-map [params]="maps" (view)="viewProduct($event)" ></app-google-map>
        </div>
        <div class="col-lg-6">
          <div class="modal-map__nav">
            <div>
              <button (click)="handleSearch(row)" *ngFor="let row of [0.2, 1, 2, 5, 'All']">
                {{ row == 'All' ? 'All' : row < 1 ? row * 1000 + "m" : row + "km" }} </button>
            </div>
          </div>
          <div *ngIf="!maps.all && !maps.home && !maps.business">
            <div class="alert alert-warning text-center mb-2" role="alert"><i class="fa-solid fa-checkmark"></i>
              Please Check Home or Business</div>
          </div>
          <div *ngIf="maps.products?.length < 1">
            <div class="alert alert-secondary text-center" role="alert"><i class="fa-solid fa-shopping-cart"></i> No
              Products Available</div>
          </div>
          <div class="d-flex flex-wrap">
            <ng-container *ngFor="let keywordSubCat of maps.subCategoriesBasedOnKeyWords">
              <ng-container *ngFor="let type of keywordSubCat.subcategoryTypes">
                <button class="btn btn-sm btn-outline-primary mr-2 mt-2" [class.active]="selectedTypesId.has(type.id)" (click)="toggleTypeAndSearch(type)">
                  {{ type.name }}
                </button>
              </ng-container>
            </ng-container>
           

          </div>
          <div class="w-100 d-flex justify-content-end">
            <button class="btn btn-sm btn-outline-primary my-2 active"  (click)="openCompareProductsModal()"><i class="fa fa-code-compare"></i>  Compare</button>
            <!-- <button class="btn btn-sm btn-outline-primary my-2 active ml-2" (click)="openRecommendationForm()">Recommend +</button> -->
          </div>
          <div *ngIf="maps.products?.length > 0" class="modal-map__body">
            <div class="products">
              <common-product-card-view (selected)="productSelectedChanged(row, $event)" [canBeSelected]="true" [isSelected]="i < 5" (view)="viewProduct($event)"
               *ngFor="let row of maps.products; index as i" [list]="row"
                [isCommunityProduct]="true" [isSearch]="true"></common-product-card-view>
              <button class="btn btn-outline-primary my-2" style="height: auto;" (click)="openRecommendationForm()">+</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>